<template>
  <div class="wx-popup-component">
    <div class="title">{{ contentList[contentType].title }}</div>
    <div class="content">{{ contentList[contentType].content }}</div>
    <div class="wx-message-img">
      <img
        v-if="contentType === 'account'"
        src="../../../assets/img/footer/tencentQrcode.png"
        ref="codeImg"
        alt=""
      />
      <img :src="qc_code_url" v-else alt="" />
    </div>
    <div class="tips">
      <template v-if="this.$root.miniprogram">
        <span>{{ contentInfo[communityType].desc }}</span>
      </template>
      <template v-else-if="groupEntryMode === 3">
        <span v-if="contentType === 'account'">点击按钮，立即关注服务号</span>
        <span v-else>点击下方按钮，立即添加</span>
      </template>
      <span v-else
        ><template v-if="!$root.$data.isApp">截屏</template
        >保存二维码，打开【微信】扫一扫，在右下角“相册”选择图片进行扫描</span
      >
    </div>
    <div class="footer" v-if="!this.$root.miniprogram">
      <div class="footer-btn" @click="groupEntryMode === 3 ? openMiniBtn() : saveImg()">
        {{ btnText }}
      </div>
    </div>
    <RemindBox v-if="isRemindBox" @closeRemindBox="closeRemindBox" />
  </div>
</template>

<script>
import wx from 'weixin-js-sdk';
import { wechatJSConfig } from '@/utils/common';
import RemindBox from '@/components/remindBox/index.vue';

export default {
  props: {
    communityInfo: {
      type: Object,
      default: () => {},
    },
  },
  components: { RemindBox },
  data() {
    return {
      isRemindBox: false,
      contentList: {
        group: {
          title: '加入备考群',
          content: '领取学习资料和更多小伙伴一起备考',
        },
        person: {
          title: '助教老师',
          content: '添加助教老师，获得更多课程资料及个性化服务',
        },
        account: {
          title: '关注服务号',
          content: '关注微信服务号，不错过任何一条重要消息',
        },
      },
      contentType: 'account',
      btnText: '保存二维码，去微信扫码',
      qc_code_url: 'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/1615366533993613908.png',
      groupEntryMode: 3,
      contentInfo: {
        '1-1': {
          desc: '请长按上方二维码保存图片，前往QQ扫描二维码添加',
        },
        '1-2': {
          desc: '请长按上方二维码保存图片，前往QQ扫描二维码添加',
        },
        '2-1': {
          desc: '请长按上方二维码保存图片，并在微信扫一扫中添加微信群',
        },
        '2-2': {
          desc: '请长按上方二维码，添加微信号',
        },
        wxAccount: {
          desc: '请长按上方二维码，添加服务号',
        },
      },
      communityType: 'wxAccount',
    };
  },
  async mounted() {
    wechatJSConfig();

    this.groupEntryMode = this.communityInfo?.groupEntryMode || 3;

    if (this.communityInfo?.accountType === 1) {
      this.contentType = 'group';
    } else if (this.communityInfo?.accountType === 2) {
      this.contentType = 'person';
    } else {
      this.contentType = 'account';
    }
    this.communityType = `${this.communityInfo.platform}-${this.communityInfo.accountType}`;

    // await this.getWxPublicAccountQcCode();
    this.qc_code_url = this.communityInfo?.qrcode || this.qc_code_url;
    // groupEntryMode=3 跳转小程序
    if (this.groupEntryMode === 3) {
      if (this.contentType === 'account') {
        this.btnText = '前往关注';
        return;
      }
      this.btnText = '前往微信添加';
      return;
    }
    if (this.$root.$data.isApp) {
      this.btnText = '保存二维码，去微信扫码';
    } else {
      this.btnText = '截屏保存二维码，去微信扫码';
    }
  },
  methods: {
    showRemindBox() {
      // 打开开播提醒
      this.isRemindBox = true;
    },
    closeRemindBox() {
      // 关闭开播提醒
      this.isRemindBox = false;
    },
    /* async getWxPublicAccountQcCode() {
      // 通过接口获取公众号的二维码图片地址
      const response = await reqTypeList('PUBLICK_QRCODE');
      this.qc_code_url = response.data[0].remark;
    }, */
    saveImg() {
      if (this.$root.$data.isApp) {
        let url = this.communityInfo?.qrcode || this.qc_code_url;
        if (this.contentType === 'account') {
          url = this.$refs.codeImg.src;
        }
        this.$sendToApp('addWechatGroup', { QRCodeUrl: url }, false);
        /* if (this.contentType === 'group' || this.contentType === 'account') {
          this.$sendToApp('addWechatGroup', { QRCodeUrl: this.qc_code_url || this.communityInfo.qrcode }, false);
        } else if (this.contentType === 'person') {
          this.$sendToApp('addWechat', {
            WechatNum: this.communityInfo.account,
          });
        } */
      } else {
        this.$toast('正在打开微信');
        setTimeout(() => {
          window.location.href = 'weixin://';
        }, 500);
      }
    },
    // 打开微信小程序并打开公众号文章界面
    openMiniBtn() {
      this.showRemindBox();
      // const { communityId } = this.communityInfo || '';
      // if (this.$root.$data.isApp) {
      //   this.$sendToApp('addWechatAppletsGroup', { communityId }, false);
      // } else {
      //   this.showRemindBox();
      // }
    },
  },
};
</script>

<style scoped lang="scss">
.wx-popup-component {
  position: relative;
  width: 100%;
  min-height: 850px;
  max-height: 928px;
  overflow: hidden;
  background: url('../../../assets/img/productDetail/wx_icon_bg.png') 0 0 no-repeat;
  background-size: 326px 261px;

  .title {
    width: 100%;
    margin-top: 58px;
    color: #333;
    font-weight: blod;
    font-size: 43px;
    line-height: 60px;
    text-align: center;
  }

  .content {
    width: 100%;
    margin-top: 58px;
    color: #333;
    font-weight: blod;
    font-size: 29px;
    line-height: 40px;
    text-align: center;
  }

  .wx-message-img {
    width: 100%;
    height: 326px;
    margin-top: 43px;
    text-align: center;

    img {
      width: 326px;
      height: 326px;
      padding: 20px;
      border: 2px solid #f5f5f5;
      border-radius: 2px;
    }
  }

  .tips {
    width: 100%;
    margin-top: 14px;
    text-align: center;

    span {
      display: inline-block;
      color: #a5a5a5;
      font-size: 22px;
      line-height: 31px;
    }
  }

  .footer {
    display: flex;
    justify-content: center;
    width: 100%;

    .footer-btn {
      width: 634px;
      height: 90px;
      margin-top: 43px;
      color: white;
      font-size: 36px;
      line-height: 90px;
      text-align: center;
      background: #ff6c02;
      border-radius: 14px;
    }
  }
}
</style>
